module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": "",
      "two-line": "",
      "subheader": ""
    }
  }, [(_vm.title) ? _c('v-subheader', [_c('strong', [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.displayFields), function(key) {
    return _c('v-list-tile', {
      key: key
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.value[key]))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(key.replace(/_/g, ' ')))])], 1)], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22decad7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/ObjectListView.vue
// module id = 1358
// module chunks = 9